import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'

export const phoneNumbersValidator = withZod(
  z.object({
    id: z.string(),
    orgId: z.string(),
    workspaceId: z.string(),
    officeMainNumber: z.string().optional(),
    officeTransferNumber: z.string().optional(),
    primaryTrackingNumber: z
      .union([
        z.object({ value: z.string(), id: z.string(), name: z.string() }).transform((option) => option.value),
        z.string().transform((val) => (val.trim() ? val : undefined)),
      ])
      .optional(),
    primarySmsNumber: z
      .union([
        z.object({ value: z.string(), id: z.string(), name: z.string() }).transform((option) => option.value),
        z.string().transform((val) => (val.trim() ? val : undefined)),
      ])
      .optional(),
  }),
)
